import { useEffect } from "react";
import { useAppUser } from "../../Context";
import { useDebounce } from "./useDebounce";
const defaultStorage = window.localStorage;
export const useUserHeaderStatePersist = hooks => {
  hooks.useOptions.push(useOptions);
  hooks.useFinalInstance.push(useFinalInstance);
};
useUserHeaderStatePersist.pluginName = "useUserHeaderStatePersist";

function useOptions(props) {
  const {
    initialState: userInitialState = {},
    storage = defaultStorage
  } = props;
  let initialState;
  const useUserHeaderStatePersistKey = useAppUser().userId + userInitialState.storageKey;

  try {
    const item = storage.getItem(useUserHeaderStatePersistKey);
    initialState = item ? JSON.parse(item) : userInitialState;
  } catch (error) {
    initialState = userInitialState;
  }

  return { ...props,
    autoResetResize: false,
    useUserHeaderStatePersistKey,
    initialState: { ...userInitialState,
      ...initialState
    }
  };
}

function useFinalInstance(instance) {
  const {
    state,
    storage = defaultStorage,
    useUserHeaderStatePersistKey
  } = instance;
  const debouncedState = useDebounce(state, 500);
  useEffect(() => {
    const {
      columnResizing,
      hiddenColumns,
      columnOrder
    } = debouncedState;
    storage.setItem(useUserHeaderStatePersistKey, JSON.stringify({
      columnResizing,
      hiddenColumns,
      columnOrder
    })); // eslint-disable-next-line
  }, [debouncedState]);
}